module.exports = __webpack_public_path__ + "static/media/un.c366cfa8.svg";